import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'debtor-panel-greeting',
  templateUrl: './greeting.component.html',
  styleUrls: ['./greeting.component.scss'],
  imports: [TranslateModule],
})
export class GreetingComponent {
  public userName = input<string | null>();
}
